import { render, staticRenderFns } from "./StackedBarChart.vue?vue&type=template&id=f6949a06&scoped=true&"
import script from "./StackedBarChart.vue?vue&type=script&lang=ts&"
export * from "./StackedBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6949a06",
  null
  
)

export default component.exports